<script setup lang="ts">

import { DropZone } from '@shared/ui/other'
import { ModalDefault } from '@shared/ui/modals'
import { AppTextarea, NativeSelect } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import DisciplineTutorSelect from '../DisciplineTutorSelect.vue'
import { useModalDisciplineFilesSend } from '../../model/modal-discipline-files-send.hook'

defineOptions({
  name: 'ModalDisciplineFilesSend',
})

const {
  refIsOpen,
  refIsLoading,
  refTitle,
  refCategoryOptions,
  refTaskOptions,
  refCategory,
  refTutorId,
  refTaskId,
  refComment,
  refUploads,
  refIsUploading,
  refCanSend,
  setCategory,
  setTask,
  setComment,
  uploadFiles,
  retryFile,
  removeFile,
  closeModal,
  sendFiles,
} = useModalDisciplineFilesSend()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    :loading="refIsLoading"
    :title="refTitle"
    @click:overlay="closeModal"
  >
    <div
      v-if="refIsOpen"
      class="modal-discipline-files"
    >
      <NativeSelect
        id="select-file-type"
        name="select_file_type"
        label="Select type of files"
        :options="refCategoryOptions"
        :value="refCategory"
        @change="setCategory"
      />
      <DisciplineTutorSelect
        v-model="refTutorId"
        label="Select tutor"
        placeholder="-- Not selected --"
        clearable
      />
      <NativeSelect
        v-if="refTaskOptions.length"
        id="select-task-tutor"
        name="select_task_tutor"
        label="Task"
        placeholder-enabled
        placeholder="Select task"
        :options="refTaskOptions"
        :value="refTaskId"
        @change="setTask"
      />
      <AppTextarea
        name="files_comment"
        label="Add comment"
        placeholder="Type here"
        :value="refComment"
        @input="setComment"
      />
      <DropZone
        :uploads="refUploads"
        :disabled="refIsLoading"
        @accept="uploadFiles"
        @retry="retryFile"
        @remove="removeFile"
      />
    </div>
    <template #controls>
      <div class="modal-discipline-files__controls">
        <BtnPrimary
          text="Send files"
          color="emerald"
          :disabled="refIsLoading || refIsUploading || !refCanSend"
          @click="sendFiles"
        />
        <BtnSecondary
          text="Cancel"
          color="black"
          :disabled="refIsLoading || refIsUploading"
          @click="closeModal"
        />
      </div>
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineFiles.scss" />
